import React, { FC } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { color, system } from 'styled-system';

import sx from '../../internal/styles/sx';
import { shouldForwardProp } from '../../internal/styles/utils';
import { IconProps } from './types';

const iconSize = {
  TINY: 'tiny',
  SMALL: 'small',
  BASE: 'base',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
} as const;

const StyledIcon = styled('svg', {
  shouldForwardProp,
})<IconProps>(
  color,
  system({
    verticalAlign: true,
    size: {
      properties: ['width', 'height'],
      scale: 'iconSizes',
    },
  }),
  {
    fill: 'currentColor',
  },
  sx
);

const Icon = React.forwardRef<
  SVGSVGElement,
  React.ComponentProps<typeof StyledIcon>
>(({ size = iconSize.MEDIUM, ...rest }, ref) => (
  <StyledIcon size={size} ref={ref} {...rest} />
));

Icon.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sx: PropTypes.object,
};

export default Icon;
export { iconSize };
